import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const photoSrc = (url) => (url?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export const useSite = () => {
  const [site, setSite] = useState(null);
  const reload = useCallback(() => api.get("/public/site").then((r) => setSite(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return [site, reload];
};

export const saveSettings = (s) =>
  api.put("/admin/settings", {
    monthly_question_limit: Number(s.monthly_question_limit),
    monthly_upload_limit: Number(s.monthly_upload_limit),
    trial_days: Number(s.trial_days ?? 0),
    trial_question_limit: Number(s.trial_question_limit ?? 15),
    followup_daily_limit: Number(s.followup_daily_limit ?? 20),
    beta_mode: s.beta_mode,
    review_mode: s.review_mode,
    voice_guide: s.voice_guide,
    alert_email: s.alert_email || null,
    focus_text: s.focus_text || "",
    focus_photo_id: s.focus_photo_id || "",
    beta_end_date: s.beta_end_date || "",
  });
